import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import React from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../../../actions/modalActions';
import Megaphone from '../../../../../assets/images/invitations/megaphone.svg';

import styles from './DiscardTyNotesModal.module.less';

const DiscardTyNotesModal = ({ onCancel, onConfirm }) => {
  return (
    <div>
      <div className="modal-header">
        <img src={Megaphone} alt="Discard thank you notes?" className={styles.svg} />
        <h2 className="modal-title">
          Are you sure you want to change to a quantity of 1 and order a proof?
        </h2>
      </div>
      <div className="modal-body">
        {/* TODO: Finalize copy */}
        <p className="text-left">
          If you do, any thank thank you notes you’ve written will be permanently deleted and your
          card will be blank. You will also disable features like our Thank You Note Generator and
          Guest Addressing. If you do not want to order a proof, press cancel.
        </p>
      </div>
      <div className="modal-footer">
        <div className="text-group row">
          <ButtonV2 onClick={onCancel} variant="secondary" className="btn-left">
            Cancel
          </ButtonV2>
          <ButtonV2 onClick={onConfirm} variant="danger" className="btn-right">
            Yes, Discard Notes
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onConfirm: () => {
    dispatch(hideModal());
    if (ownProps.callback) ownProps.callback();
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DiscardTyNotesModal);
